import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  type User
} from "firebase/auth";
import { readonly, ref } from "vue";

const firebaseApp = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDHK6p9Suf90mI2tzIwK9KV8CfpedflfZo",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "alert-tine-502807-e1.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "alert-tine-502807-e1",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "alert-tine-502807-e1.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1078181891220",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1078181891220:web:6d23a76c066aced10b3881"
});

const auth = getAuth(firebaseApp);
auth.useDeviceLanguage();
void setPersistence(auth, browserLocalPersistence);

const currentUser = ref<User | null>(null);
let resolveReady: () => void;
const readyPromise = new Promise<void>((resolve) => { resolveReady = resolve; });
onAuthStateChanged(auth, (user) => {
  currentUser.value = user;
  resolveReady();
});

export const firebaseUser = readonly(currentUser);
export const waitForFirebaseAuth = () => readyPromise;

export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  await signInWithPopup(auth, provider);
}

export async function signInWithEmail(email: string, password: string) {
  await signInWithEmailAndPassword(auth, email.trim(), password);
}

export async function signOutAdmin() {
  await signOut(auth);
}

export async function getAdminIdToken(forceRefresh = false) {
  await waitForFirebaseAuth();
  if (!auth.currentUser) throw new Error("請先登入管理後台。");
  return auth.currentUser.getIdToken(forceRefresh);
}
